import { AnimatePresence, motion } from "framer-motion";
import { X, Star, ArrowUpRight, ShieldCheck, Truck } from "lucide-react";

export const QuickView = ({ product, onClose }) => (
  <AnimatePresence>
    {product && (
      <motion.div
        data-testid="quick-view-dialog"
        role="dialog"
        aria-modal="true"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm"
        onClick={onClose}
      >
        <motion.div
          initial={{ opacity: 0, y: 32, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.97 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          onClick={(e) => e.stopPropagation()}
          className="relative w-full max-w-2xl overflow-hidden rounded-2xl border border-white/10 bg-[#121418]"
        >
          <button
            data-testid="quick-view-close-btn"
            onClick={onClose}
            aria-label="Close quick view"
            className="absolute right-4 top-4 z-10 rounded-full border border-white/10 bg-black/60 p-2 text-slate-200 backdrop-blur-md transition-colors hover:bg-[#FF9900] hover:text-[#0B0C0E]"
          >
            <X size={16} />
          </button>
          <div className="grid md:grid-cols-2">
            <div className="relative h-64 md:h-full">
              <img src={product.image} alt={product.title} className="h-full w-full object-cover" />
              <span className="absolute left-4 top-4 rounded-full bg-black/60 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-[#FFB800] backdrop-blur-md">
                {product.badge}
              </span>
            </div>
            <div className="flex flex-col gap-3 p-6 md:p-8">
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">{product.category}</p>
              <h3 className="font-display text-2xl font-bold tracking-tight text-slate-50">{product.title}</h3>
              <div className="flex items-center gap-1.5 text-sm text-slate-400">
                <Star size={14} className="fill-[#FF9900] text-[#FF9900]" />
                <span className="font-mono font-semibold text-slate-200">{product.rating}</span>
                <span>({product.reviews.toLocaleString()} reviews)</span>
              </div>
              <p className="text-sm leading-relaxed text-slate-300">{product.description}</p>
              <div className="mt-1 flex flex-col gap-1.5 text-xs text-slate-400">
                <span className="inline-flex items-center gap-1.5"><Truck size={13} className="text-[#FF9900]" /> Fast Prime shipping</span>
                <span className="inline-flex items-center gap-1.5"><ShieldCheck size={13} className="text-[#FF9900]" /> Amazon buyer protection</span>
              </div>
              <div className="mt-auto flex items-center justify-between pt-4">
                <span className="font-mono text-2xl font-bold text-[#FF9900]">{product.price}</span>
                <a
                  data-testid="quick-view-buy-btn"
                  href={product.link}
                  target="_blank"
                  rel="noopener noreferrer sponsored"
                  className="inline-flex items-center gap-2 rounded-full bg-[#FF9900] px-5 py-2.5 text-sm font-bold text-[#0B0C0E] transition-all duration-200 hover:bg-[#FFB800] active:scale-95"
                >
                  Buy on Amazon
                  <ArrowUpRight size={15} />
                </a>
              </div>
            </div>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
